import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { LoginService } from "../services/login.service";

@Component({
	selector: "app-forgot-username",
	templateUrl: "./forgot-username.component.html",
	styleUrls: ["./forgot-username.component.css"],
})
export class ForgotUsernameComponent implements OnInit {
	constructor(private ref: DynamicDialogRef, private loginService: LoginService, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {}

	/////////////////////////////
	// Data
	/////////////////////////////
	Email: any = "";

	loading: any = false;

	errorMessage: any = "";

	/////////////////////////////

	/////////////////////////////
	// Buttons
	/////////////////////////////
	onSendUsername() {
		this.errorMessage = "";

		//Error Handling
		if (this.Email == "") {
			this.errorMessage = "Enter an email address";
			return;
		}

		this.loading = true;

		var result = this.loginService.ForgotUsername(this.Email);
		result.subscribe(
			(response) => {
				var MSG = response[0];

				if (MSG != undefined) {
					this.confirmationService.confirm({
						key: "username",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: MSG,
						header: "Forgot Username",
						icon: "fa",
						accept: () => {
							this.loading = false;

							if (response[1] != undefined && response[1] == "success") {
								this.ref.close(1);
							}
						},
					});
				}
			},
			(error) => {
				this.confirmationService.confirm({
					key: "username",
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "An error has occured",
					header: "ERROR",
					icon: "fa",
					accept: () => {
						this.loading = false;
					},
				});
			}
		);
	}

	onCancel() {
		this.ref.close(0);
	}

	/////////////////////////////
}
